import color from 'styles/color.json';
import { AbsoluteThemeColorType } from 'styles/theme';

export enum DisplayMode {
  R3_MOTRIO = 'R3_MOTRIO',
  DARK = 'dark',
}

export type DisplayModeType = typeof DisplayMode.DARK | typeof DisplayMode.R3_MOTRIO;

interface DisplayModeProps {
  brandColor: AbsoluteThemeColorType;
  searchFontColor: AbsoluteThemeColorType;
  secondaryColor: AbsoluteThemeColorType;
  searchBackgroundColor: AbsoluteThemeColorType;
}

export const displayMode: Record<DisplayModeType, DisplayModeProps> = {
  dark: {
    brandColor: color.brand_black,
    searchFontColor: color.white,
    secondaryColor: color.white65,
    searchBackgroundColor: color.grey30,
  },
  R3_MOTRIO: {
    brandColor: color.brand_black,
    searchFontColor: color.white,
    secondaryColor: color.white85,
    searchBackgroundColor: color.grey30,
  },
};
